import type {
  ListProductsRequest,
  Product,
  ProductListResponse,
} from "@sakura-tech-lab/dashboard-api";

import { productsApi } from "@/services/dashboard-api.client";

export async function listProducts(
  request: ListProductsRequest,
): Promise<ProductListResponse> {
  const response = await productsApi.listProducts(request);
  if (!response.success) {
    throw new Error("Failed to load products");
  }
  return response;
}

export async function getProduct(
  catalogueId: string,
  productId: string,
): Promise<Product> {
  const response = await productsApi.getProduct({ catalogueId, id: productId });
  return response.data;
}
